import Form from 'components/form';
import MuiRadioGroup from 'components/form/RadioGroup';
import React from 'react';
import { useForm } from './Form';
const { FormItem } = Form;

const RadioGroup = ({ id, value, required, isValid, touched, options }) => {
  const { getFieldDecorator } = useForm();

  return (
    <FormItem>
      {getFieldDecorator(id, {
        initialValue: value,
        rules: [{ required, message: 'Required' }],
        normalize: (value) => {
          return value === 'true' ? true : value === 'false' ? false : value;
        },
      })(<MuiRadioGroup row={options.length <= 2} options={options} />)}
    </FormItem>
  );
};

export default RadioGroup;
